import { styled } from '@mui/material/styles';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import { palette } from 'themeV5/palette';

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  itemMenu: {
    margin: 0,
    minWidth: 263,
    boxShadow: 'none',
    backgroundColor: palette.dark.main,
    '&:hover': {
      backgroundColor: '#F4F2F9',
    },
    '@media (hover: none) and (pointer: coarse)': {
      '&:hover': {
        backgroundColor: palette.dark.main,
      },
    },
  },
  listItem: (theme: Theme) => ({
    padding: 0,
    width: '100%',
    marginBottom: theme.spacing(2),
  }),
  textItem: {
    fontWeight: 'normal',
    fontSize: '13px',
    alignSelf: 'center',
    color: '#525067',
    '&:hover': {
      color: '#6D46DD',
    },
  },
  textItemExpanded: {
    fontWeight: 'normal',
    fontSize: '13px',
    alignSelf: 'center',
    color: '#6D46DD',
  },
  textItemContacted: {
    fontWeight: 'normal',
    fontSize: '13px',
    alignSelf: 'center',
    color: '#F4F2F9',
  },
  textItemLight: {
    fontWeight: 'normal',
    fontSize: '13px',
    alignSelf: 'center',
    color: '#F4F2F9',
    '&:hover': {
      backgroundColor: '#6D46DD',
    },
  },
  itemList: (theme: Theme) => ({
    padding: 0,
    paddingLeft: theme.spacing(10),
    minWidth: 263,
  }),
  details: {
    width: '100%',
    backgroundColor: '#F4F2F9',
  },
} satisfies Record<string, StyleEntry>;

export const AccordionSummary = styled(MuiAccordionSummary)({
  '&&': {
    '&.Mui-expanded': {
      margin: '4px 0 0',
      backgroundColor: '#F4F2F9',
    },
    '& .MuiAccordionSummary-content': {
      margin: '4px 0',
      '&.Mui-expanded': {
        margin: '4px 0 1px 0',
      },
    },
  },
});
